import React from 'react';
import useMedia from 'use-media';

export const Heart = ({ className }) => {
  const isTablet = useMedia({ minWidth: '768px' });
  const isDesktop = useMedia({ minWidth: '1024px' });
  const isWide = useMedia({ minWidth: '1280px' });

  let width = 400;
  if (isTablet) width = 250;
  if (isDesktop) width = 300;
  if (isWide) width = 350;

  return (
    <svg
      width={width}
      viewBox="0 0 333 626"
      fill="none"
      className={className}
      style={{ right: 0, bottom: isDesktop ? -300 : 0, zIndex: -1 }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5318 177.305C72.1326 150.712 108.206 135.773 145.82 135.773C183.433 135.773 219.507 150.712 246.108 177.305L287.67 218.832L329.232 177.305C342.317 163.757 357.97 152.951 375.276 145.516C392.582 138.082 411.196 134.169 430.03 134.005C448.865 133.842 467.544 137.431 484.977 144.563C502.41 151.695 518.247 162.228 531.566 175.547C544.885 188.866 555.418 204.703 562.55 222.136C569.682 239.569 573.271 258.248 573.108 277.083C572.944 295.917 569.031 314.531 561.597 331.837C554.162 349.144 543.356 364.796 529.808 377.881L287.67 620.055L45.5318 377.881C18.939 351.28 4 315.207 4 277.593C4 239.98 18.939 203.906 45.5318 177.305V177.305Z"
        fill="#FEB2B2"
        stroke="#742A2A"
        strokeWidth={isDesktop ? '8' : '6'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5318 112.305C72.1326 85.7124 108.206 70.7734 145.82 70.7734C183.433 70.7734 219.507 85.7124 246.108 112.305L287.67 153.832L329.232 112.305C342.317 98.757 357.97 87.9506 375.276 80.5163C392.582 73.0821 411.196 69.169 430.03 69.0054C448.865 68.8417 467.544 72.4307 484.977 79.5631C502.41 86.6954 518.247 97.2282 531.566 110.547C544.885 123.866 555.418 139.703 562.55 157.136C569.682 174.569 573.271 193.248 573.108 212.083C572.944 230.917 569.031 249.531 561.597 266.837C554.162 284.144 543.356 299.796 529.808 312.881L287.67 555.055L45.5318 312.881C18.939 286.28 4 250.207 4 212.593C4 174.98 18.939 138.906 45.5318 112.305V112.305Z"
        fill="#FED7D7"
        stroke="#742A2A"
        strokeWidth={isDesktop ? '8' : '6'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5318 47.3051C72.1326 20.7124 108.206 5.77336 145.82 5.77336C183.433 5.77336 219.507 20.7124 246.108 47.3051L287.67 88.8317L329.232 47.3051C342.317 33.757 357.97 22.9506 375.276 15.5163C392.582 8.08212 411.196 4.16902 430.03 4.00536C448.865 3.84169 467.544 7.43074 484.977 14.5631C502.41 21.6954 518.247 32.2282 531.566 45.5469C544.885 58.8656 555.418 74.7034 562.55 92.1363C569.682 109.569 573.271 128.248 573.108 147.083C572.944 165.917 569.031 184.531 561.597 201.837C554.162 219.144 543.356 234.796 529.808 247.881L287.67 490.055L45.5318 247.881C18.939 221.28 4 185.207 4 147.593C4 109.98 18.939 73.906 45.5318 47.3051V47.3051Z"
        fill="#FFF5F5"
        stroke="#742A2A"
        strokeWidth={isDesktop ? '8' : '6'}
      />
      <path
        d="M125.894 99.4123C117.17 99.4123 108.803 102.885 102.633 109.068C96.4649 115.252 93 123.639 93 132.383C93 141.128 96.4649 149.514 102.633 155.699L158.086 211.29C158.477 211.682 159.112 211.682 159.502 211.29L214.956 155.699C218.098 152.656 220.605 149.017 222.329 144.994C224.053 140.971 224.961 136.643 224.999 132.264C225.037 127.886 224.204 123.543 222.55 119.49C220.896 115.437 218.453 111.755 215.364 108.659C212.274 105.563 208.601 103.114 204.558 101.456C200.514 99.7976 196.182 98.9632 191.813 99.0012C187.445 99.0393 183.128 99.949 179.114 101.677C175.1 103.406 171.469 105.918 168.434 109.068L159.502 118.013C159.111 118.405 158.477 118.405 158.087 118.013L149.154 109.068C142.985 102.885 134.618 99.4123 125.894 99.4123Z"
        fill="white"
        stroke="#742A2A"
        strokeWidth={isDesktop ? '8' : '6'}
      />
    </svg>
  );
};
